import React from "react";
import { LongTextLabel, Tooltip } from "@sscs/ui";
import { getClassName, parsePurl } from "@sscs/utils";
import { USER_REMOVED } from "Constants";
import styles from "./uploadedByInfo.module.scss";

type UploadedByInfoProps = {
  user: {
    first_name: string;
    last_name: string;
    email: string;
  } | null;
  importedFrom: string | null;
};

const UploadedByInfo = ({ user, importedFrom }: UploadedByInfoProps) => {
  const isUnknown = !user;
  let domain;
  let isPurl = false;

  if (importedFrom) {
    if (importedFrom.startsWith("pkg")) {
      try {
        parsePurl(importedFrom);
        domain = importedFrom;
        isPurl = true;
      } catch {
        // we don't care about invalid purl
      }
    } else {
      try {
        domain = new URL(importedFrom).hostname;
      } catch {
        // we don't care about invalid url
      }
    }
  }

  return (
    <small className={styles["uploaded-by-text"]}>
      {domain && importedFrom ? (
        <>
          Imported from{" "}
          <Tooltip
            trigger="term"
            title={isPurl ? <code>{importedFrom}</code> : importedFrom}
          >
            <span className={getClassName({ [styles.purl]: isPurl })}>
              <LongTextLabel inline label={domain} maxCharacters={70} />
            </span>
          </Tooltip>{" "}
          by{" "}
        </>
      ) : (
        <>Uploaded by </>
      )}
      <Tooltip
        trigger="term"
        title={
          isUnknown
            ? USER_REMOVED
            : `${user.first_name} ${user.last_name} (${user.email})`
        }
      >
        <small>
          {isUnknown ? (
            USER_REMOVED
          ) : (
            <LongTextLabel inline label={user.email} maxCharacters={70} />
          )}
        </small>
      </Tooltip>
    </small>
  );
};

export default UploadedByInfo;
